import { render, staticRenderFns } from "./PurchasePdfGenerator.vue?vue&type=template&id=2c295195&scoped=true"
import script from "./PurchasePdfGenerator.vue?vue&type=script&lang=js"
export * from "./PurchasePdfGenerator.vue?vue&type=script&lang=js"
import style0 from "./PurchasePdfGenerator.vue?vue&type=style&index=0&id=2c295195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c295195",
  null
  
)

export default component.exports